import { render } from "./AllocationState.vue?vue&type=template&id=42053ef3&scoped=true"
import script from "./AllocationState.vue?vue&type=script&lang=js"
export * from "./AllocationState.vue?vue&type=script&lang=js"

import "./AllocationState.vue?vue&type=style&index=0&id=42053ef3&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-42053ef3"

export default script